const services = [
  {
    icon: 'ri-book-2-line',
    title: 'Bookkeepers & Accountants',
    description:
      'Reliable support for AP/AR, monthly close, reconciliation, and full-cycle reporting.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Tax Season Support',
    description:
      'Extra hands during peak season, without a permanent hire.',
  },
  {
    icon: 'ri-team-line',
    title: 'Capacity Support',
    description:
      'Never turn away a client for lack of staff.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'CAS Team Support',
    description:
      "Dedicated staff for your firm's client accounting services, scaling as you grow.",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-14 md:py-24 px-4 sm:px-6 lg:px-16 bg-white relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#F49729]/5 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-[#F49729]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-10 md:mb-20">
          <p className="text-[#F49729] text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase mb-4 md:mb-5">
            What We Do
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111] leading-tight">
            Comprehensive Recruitment
            <br />
            Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative p-5 md:p-10 rounded-2xl md:rounded-3xl bg-gradient-to-br from-white to-[#faf9f7] border border-gray-100 hover:border-[#F49729]/30 transition-all duration-300 hover:shadow-xl hover:shadow-[#F49729]/5 cursor-default"
            >
              <div className="w-11 h-11 md:w-16 md:h-16 flex items-center justify-center rounded-xl md:rounded-2xl bg-gradient-to-br from-[#F49729]/10 to-[#F49729]/5 text-[#F49729] mb-4 md:mb-7 group-hover:from-[#F49729] group-hover:to-[#e08820] group-hover:text-white transition-all duration-300">
                <i className={`${service.icon} text-xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-xl font-semibold text-[#111111] mb-2 md:mb-4">
                {service.title}
              </h3>
              <p className="text-sm text-[#61616A] leading-relaxed">
                {service.description}
              </p>
              <div className="absolute bottom-0 right-0 w-24 h-24 bg-[#F49729]/5 rounded-tl-[60px] rounded-br-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
